<script lang="ts" setup>
  import { usePaymentDialog } from '@/composables/usePaymentDialog.ts'

  const { model, hide, emitClose } = usePaymentDialog()
  const trackStore = useTrackStore()
  const onClose = () => {
    emitClose()
    hide()
  }

  watch(model, () => {
    if (model.value) {
      trackStore.track('sina_pro_presented', {
        version: trackStore.subscriptionVersion,
      })
    }
  })
</script>

<template>
  <v-dialog
    v-model="model"
    :fullscreen="$vuetify.display.mdAndDown"
    :max-height="$vuetify.display.mdAndDown? 'auto' : '807px'"
    :max-width="$vuetify.display.mdAndDown? 'auto':'536px'"
    scrollable
    transition="dialog-bottom-transition"
    @update:model-value="(val) => {if (!val) onClose()}"
  >
    <subscription @close="onClose" />
  </v-dialog>
</template>
